import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../Components/InvoiceDetails/style";
import React, { useState, useEffect, useRef } from "react";
import TaxDetail from "../Components/TaxDetails/TaxDetails";
import { Delete, Error } from "@material-ui/icons";
import { Download } from "@material-ui/icons";
import {
  Grid,
  TextField,
  Autocomplete,
  Typography,
  Backdrop,
  CircularProgress,
  IconButton,
  FormControl,
  Button,
  Box,
  InputAdornment,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import AttachmentsCover from "../../../components/Attachments/AttachmentsCover";
import {
  clearState,
  getCommentsByInvoiceId,
  getInvoiceByInvoiceIdAndRoleId,
  getVendorByPO,
  updateIPInvoice,
  getAllInvoiceDetailByInvoiceId,
  vendorTaxDetailForCnic,
  changeInvoiceStatus,
  getRefrenceDataList,
  getImportPoData,
  updateIPInvoiceByImport,
  uploadAdditioalDocumentFile,
  putDeptCoordinatorAndReviewerInvoice,
  getUsersByRole,
  putLM_SSM_DHR,
  getBatchInvoiceDetails,
} from "../actions";
import TaxTable from "../NewInvoice/Tables/Tax_Table";
import InvoiceRadioButtons from "../Components/InvoiceDetails/InvoiceRadiobuttons";
import InvoiceTextField from "../Components/InvoiceDetails/InvoiceTextFields";
import InvoiceDetailTextField from "../Components/InvoiceDetails/InvoiceDetailTextFields";
import InvoiceCheckboxes from "../Components/InvoiceDetails/InvoiceCheckboxes";
import Card from "../../../StyledComponents/Card/Card";
import CardHeader from "../../../StyledComponents/Card/CardHeader";
import CardText from "../../../StyledComponents/Card/CardText";
import CardBody from "../../../StyledComponents/Card/CardBody";
import getParameterByName from "../../../Functions/functions";
import { ArrowBack } from "@material-ui/icons";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import GL_Table from "../NewInvoice/Tables/GL_Table";
import UsersByRole from "../NewInvoice/Dropdowns/UsersByRole";
import downloadAttachments from "../../../Functions/downloadAttachments";
import { getUserRoles } from "../../Home/actions";
import WarningBox from "../Components/WarningBox";
import CustomSnackbar from "../../../CustomSnackbar";
import TaxTable_Short from "../NewInvoice/Tables/Tax_Table_Short";
import ExpenseTable from "../NewInvoice/Tables/ExpenseTable";
import Vendor_Table from "../NewInvoice/Tables/Vendor_Table";
import Heading from "../../../StyledComponents/Heading/Heading";
import CommentHistory from "../NewInvoice/Tables/CommentHistory";
import POAlertDialog from "../NewInvoice/Tables/PoTableAlert";
import { GetBatchInvoiceDetailsWithname } from "../ProcessInvoice/actions";
import GL_Table_Detail_HR from "../NewInvoice/Tables/GL_Table_Detail_HR";
const useStyles = makeStyles(dashboardStyle);

// LM_SSM_DHR ==>>> Line Manager _ Shared Services _ Director HR
// <<<<<<=======SCREEN========>>>>>>

const LM_SSM_DHRDetail = () => {
  const navigate = useNavigate();
  const invoiceId = getParameterByName("invoiceId");
  const roleId = getParameterByName("roleId");
  const roleName = getParameterByName("roleName");
  const vendorCode = getParameterByName("vendorCode");

  const invoicePayload = {
    Invoice_id: invoiceId,
    Vendor_Code: vendorCode,
  };
  const role = {
    roleId: roleId,
    roleName: roleName,
  };
  const [openInvalidWarningDate, setOpenInvalidWarningDate] = useState(false);
  const [attachmentURL, setAttachmentURL] = useState("");
  const [attachmentURLList, setAttachmentURLList] = useState([]);
  const [poBasedState, setPoBasedState] = useState("Non-PO");
  const [physicalOrEInvoice, setPhysicalOrEInvoice] = useState("Physical");
  const [rolesLoading, setRolesLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [attachInvoiceLoading, setAttachInvoiceLoading] = useState(false);
  const [commentsList, setCommentsList] = useState([]);
  const [commentsLoading, setCommentsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(
    role ? { roleName: role?.roleName } : ""
  );
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const invoice_attachmentRef = useRef(null);

  const additionalAttachmentRef = useRef(null);

  const [formState, setFormState] = useState({
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    invoice_Accounts_list: [],
    updated_On: new Date(),
    comments: "",
    aditional_Comments: "",
    invoiceDocURL: "",
    invoiceLocation: "",
    employeeCode: "",
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isPSID: false,
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: new Date(),
    // submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    pcdvLocation: "",
    pcdvSegment: "",

    psid: "",
    urgent: false,
    eInvoice: true,
    invoice_Date: moment().format("YYYY-MM-DD"),
    invoice_Id: invoicePayload?.Invoice_id,
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    vendor_Code: "",
    vendor_Name: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    due_Date: new Date(),
    fsDocumentDate: "",
    fsDocumentNumber: "",
    //   for import invoice (extra field)
    currency: "PKR",
    posting_Date: new Date(),
    document_Type: "",
    created_By: "",
    // vendor Detail
    vendor_Details: [],

    // =======import invoice some tables are below ==========
    additionalDocIds_array: [], // additional documents in array

    // G/L Account detail. (actually for po_normal isInitiator)
    // (will change it to "invoice_Accounts_Details" for import invoice before hit api)
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "",
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],

    Expense_Accounts_list: [
      // Invoice_Accounts_list for back-end
      {
        expenseDate: "",
        description: "",
        amount: 0,
        glAccount: "",
        costCenter: "",
        fixedAsset: "",
        tType: "",
        profitCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        department: "",
      },
    ],

    verified: false,
  });

  const classes = useStyles();

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [deleteLoader, setdeleteLoader] = useState(false);

  const showAttachmentsHandler = (attachment_URL) => {
    setAttachmentURL(attachment_URL);
  };

  const showVendorAndPO_NumberForImport = () => {
    let show =
      selectedRole?.roleName === "Department Coordinator" ? true : false;
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Deposit"
    ) {
      show = false;
    }
    if (
      selectedRole?.roleName === "Import" &&
      formState.demandType === "Samples"
    ) {
      show = false;
    }

    return show;
  };

  const [newFormState, setNewFormState] = useState({
    courier_Tracking_No: "",
    created_On: new Date(),
    updated_By: "",
    invoice_Accounts_list: [],
    updated_On: new Date(),
    comments: "",
    aditional_Comments: "",
    invoiceDocURL: "",
    invoiceLocation: "",
    employeeCode: "",
    isInitiator: false,
    isDeptCordinator: false,
    isHR: false,
    isPCDV: false, // EFDV initiator
    isPSID: false,
    isVPPayment: false,
    isVFPayment: false,
    isSubmittedByVendor: false,
    isImport: false,
    isLogistics: false,
    submission_Date: new Date(),
    // submission_Date: moment().format("YYYY-MM-DD"),
    pO_Based: true,
    pcdvLocation: "",
    pcdvSegment: "",

    psid: "",
    urgent: false,
    eInvoice: true,
    invoice_Date: moment().format("YYYY-MM-DD"),
    invoice_Id: invoicePayload?.Invoice_id,
    barcode_No: "",
    demandType: "",
    invoice_Type: "",
    invoice_No: "",
    invoiceCategory: "",
    invoice_Desc: "",
    invoice_Amount: 0,
    final_Invoice_Amount: "",
    dept_coordinator: "",
    irUser: "",
    ipUser: "",
    vendor_Code: "",
    vendor_Name: "",
    lineManager: "",
    directorHR: "",
    sharedServices: "",
    invoice_attachment: "",
    additionalDocIds: [], // paths
    due_Date: new Date(),
    fsDocumentDate: "",
    fsDocumentNumber: "",

    //   for import invoice (extra field)
    currency: "PKR",
    posting_Date: new Date(),
    document_Type: "",
    created_By: "",
    // vendor Detail
    vendor_Details: [],

    // =======import invoice some tables are below ==========
    additionalDocIds_array: [], // additional documents in array

    // G/L Account detail. (actually for po_normal isInitiator)
    // (will change it to "invoice_Accounts_Details" for import invoice before hit api)
    invoice_Accounts: [
      // {
      //   accountId: 0,
      //   invoice_Id: 0,
      //   glAccount: "",
      //   costCenter: "",
      //   accountType: "",
      //   amount: 0,
      //   costCenterOwner: "",
      //   stCode: "",
      //   order: "",
      //   profitCenter: "",
      //   wbsElement: "",
      //   created_By: "",
      //   created_On: new Date(),
      //   updated_By: "",
      //   updated_On: new Date(),
      //   fixedAsset: "",
      //   tType: "",
      //   description: "",
      //   expenseDate: "",
      //   horizonId: "",
      //   department: "",
      //   vendorCode: "",
      // },
    ],

    Expense_Accounts_list: [
      // Invoice_Accounts_list for back-end
      {
        expenseDate: "",
        description: "",
        amount: 0,
        glAccount: "",
        costCenter: "",
        fixedAsset: "",
        tType: "",
        profitCenter: "",
        costCenterOwner: "",
        costCenterOwnerName: "",
        horizonId: "",
        vendorCode: "",
        department: "",
      },
    ],

    verified: false,
  });

  const [multipleData, setMultipleData] = useState({
    sglInd: [],
    tType: [],
    glAccount: [],
    postingKey: [],
    paymentDetail: [],
    paymentMethod: [],
    paymentTerms: [],
    paymentMethSupp: [],
    poData: [],
    vendorTaxDetail: [],
    currency: [],
    invoice_Type: [],
  });

  const [userData, setUserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const confirmHandler = (e) => {
    e.preventDefault();
    setOpenWarningBox(true);
  };

  useEffect(() => {
    let filterd_data = [];
    if (formState?.additionalDocIds?.length > 0) {
      filterd_data = formState.additionalDocIds.filter((e) => Number(e) !== 0);
    }
    setAttachmentURLList((pre) => [
      formState?.invoice_attachment,
      ...filterd_data,
    ]);
    if (formState?.invoice_attachment) {
      setAttachmentURL(formState?.invoice_attachment);
    } else {
      setAttachmentURL(formState?.additionalDocIds[0]);
    }
  }, [formState?.invoice_attachment, formState?.additionalDocIds]);

  useEffect(() => {
    if (newFormState?.additionalDocIds?.length > 0) {
      setAttachmentURLList((pre) => [
        ...pre,
        newFormState?.additionalDocIds[
        newFormState?.additionalDocIds.length - 1
        ],
      ]);
    }
  }, [newFormState?.additionalDocIds]);

  useEffect(() => {
    setNewFormState(formState);
    setNewFormState((newFormState) => ({
      ...newFormState,
      additionalDocIds: [],
    }));
  }, [formState]);

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setNewFormState((newFormState) => ({
      ...newFormState,
      [name]: value,
    }));
  };
  // useEffect(()=>{
  //   if(formState){
  //     setNewFormState((newFormState) => ({
  //       ...newFormState,
  //       vendor_Details: formState?.vendor_Details,
  //     }));
  //   }

  // },[]);

  const submitHandler = () => {
    const additionalDocIds = [];
    for (let i = 0; i < newFormState?.additionalDocIds?.length; i++) {
      const item = newFormState?.additionalDocIds[i];
      additionalDocIds.push(item?.path);
    }
    const data = {
      invoice_Id: parseInt(invoicePayload?.Invoice_id),
      additionalDocIds: additionalDocIds,
      comment: newFormState.comments,
      isReject: newFormState?.isReject === true ? true : false,
      updated_By: "",
    };

    putLM_SSM_DHR(
      data,
      newFormState,
      setNewFormState,
      setErrorMessage,
      setSuccessMessage,
      setAttachInvoiceLoading,
      navigate
    );
    setOpenWarningBox(false);
  };
  const [dataLoading, setDataLoading] = useState("false")
  useEffect(() => {
    getRefrenceDataList(
      "invoiceType",
      "invoice_Type",
      () => { },
      setMultipleData
    );
    getUserRoles(setRoles, setRolesLoading);

    if (invoicePayload && role) {
      vendorTaxDetailForCnic(setFormState, invoicePayload?.Vendor_Code);
      // getInvoiceByInvoiceIdAndRoleId(invoicePayload, role, setFormState);
      // getInvoiceByInvoiceIdAndRoleId(
      //   setIsLoading,
      //   invoicePayload,
      //   role,
      //   setFormState
      // );
      GetBatchInvoiceDetailsWithname(
        () => { },
        () => { },
        setMultipleData,
        invoicePayload,
        role,
        setFormState,
        setDataLoading,
        setPoBasedState
      )
      getCommentsByInvoiceId(
        setCommentsList,
        setCommentsLoading,
        invoicePayload?.Invoice_id
      );

      // if (!formState.isImport) {
      // getAllInvoiceDetailByInvoiceId(
      //   setFormState,
      //   setMultipleData,
      //   invoicePayload?.Invoice_id,
      //   () => {},
      //   () => {},
      //   "",
      //   () => {}
      // );
      // }
    }
  }, []);



  const [vendor__Code, setVendor__Code] = useState("");
  useEffect(() => {
    if (formState?.vendor_Code) {
      setVendor__Code(formState?.vendor_Code);
    } else {
      setFormState((formState) => ({
        ...formState,
        vendor_Code: vendor__Code,
      }));
    }
  }, [formState.vendor_Code]);

  useEffect(() => {
    if (formState?.invoice_Accounts_list?.length > 0) {
      let temp = [];
      for (let i = 0; i < formState?.invoice_Accounts_list?.length; i++) {
        const item = formState?.invoice_Accounts_list[i];
        const obj = {
          accountId: 0,
          invoice_Id: Number(invoicePayload?.Invoice_id),
          glAccount: item?.GLAccount,
          costCenter: { CostCenterCode: item?.CostCenter || "" },
          costCenterOwner: item?.CostCenterOwner,
          costCenterOwnerName: item?.CostCenterOwnerName,
          wbsElement: item?.WBSElement,
          horizonId: item?.HorizonId,
          vendor_Code: { Vendor_Code: item?.VendorCode, Vendor_Name: "" },
          amount: item?.Amount,
          profitCenter: item?.ProfitCenter,
          department: item?.Department,
          description: item?.Description || "",
          tType: item?.TType || "",
          fixedAsset: item?.FixedAsset || "",
        };
        temp.push(obj);
      }
      setNewFormState((formState) => ({
        ...formState,
        invoice_Accounts_list: temp,
        Expense_Accounts_list: temp,
      }));
    }
  }, [formState]);
  const [dragfile, setDragFile] = useState(false);
  const [dragloader, setDragLoader] = useState(false);
  const [docError, setDocError] = useState("");
  const [attachError, setAttachError] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [invoicedelete, setInvoiceDelete] = useState("");
  const [warningFlag, setWarningFlag] = useState(false);

  const deleteAttachmentFunc = () => {
    const data = {
      Id: invoicedelete?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(
          (x) => x?.path !== invoicedelete?.path
        );
        const files = newFormState.additionalDocIds.filter(
          (x, i) => x.path !== invoicedelete?.path
        );
        setAttachmentURLList(final);

        setNewFormState((formState) => ({
          ...formState,
          additionalDocIds: files,
        }));

        setdeleteLoader(false);
        setWarningFlag(false);

        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        setErrorMessage(error.response.data);
      });
  };
  const handleDrag = function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragLoader(true);
    } else if (e.type === "dragleave") {
      setDragLoader(false);
      setDragFile(true);
    }
  };
  const handleDrop = function (e) {
    e.preventDefault();
    e.stopPropagation();
    setDragLoader(false);

    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      uploadAdditioalDocumentFile(
        e,
        setNewFormState,
        setAttachInvoiceLoading,
        "additionalDocIds",
        additionalAttachmentRef,
        setDocError,
        setAttachError,
        setAlertMessage,
        invoicePayload,
        selectedRole,
        dragfile,
        setDragFile,
        setSuccessMessage
      );
    }
  };
  return (
    <Card
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={dragloader}
      ></Backdrop>
      <CardHeader color="primary" text>
        <CardText
          style={{
            padding: "0px 27px",
            backgroundColor: "#031C30",
            color: "white",
          }}>
          <Grid container justifyContent="space-between">
            <Grid item xs={2} sm={3} md={3} lg={6}>
              <h1 style={{ fontSize: "24px" }}>
                {
                  selectedRole?.roleName === "Line Manager" ? "Line Manager" :
                    selectedRole?.roleName === "Shared Services" ? "Manager Shared Services" : "Director HR"
                }
              </h1>
            </Grid>
            <Grid item xs={6} sm={6} md={6} lg={6}>
              <IconButton
                variant="contained"
                style={{ float: "right", marginTop: "1.5%" }}
                onClick={() => navigate("/home")}
              >
                <ArrowBack style={{ color: "#fff" }} titleAccess="Go Back" />
              </IconButton>
            </Grid>
          </Grid>
        </CardText>
      </CardHeader>
      <CardBody>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={attachInvoiceLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Grid container style={{ marginTop: "2px", padding: "0px 5px" }}>
          {/* Submitter role */}
          <Grid item xs={12} sm={12} md={3} lg={3} style={{ marginTop: "8px" }}>
            <Typography style={{ color: "black" }}>
              Submitter Role:
            </Typography>
            <Autocomplete
              id="submitter_role"
              options={roles}
              size="small"
              value={selectedRole}
              getOptionLabel={(option) =>
                (option !== "" && `${option?.roleName}`) || ""
              }
              loading={rolesLoading}
              disabled
              renderInput={(params) => (
                <TextField {...params} type="text" name="" required />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={9} lg={9}></Grid>
        </Grid>

        <Grid container style={{ padding: "0px 6px" }}>
          <Grid item xs={12} sm={12} md={12} lg={6}>
            { /*<InvoiceTextField
              newFormState={formState}
              setNewFormState={setFormState}
              selectedRole="Line Manager"
              disabled={true}
              poBasedState={poBasedState}
              showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
              showVendorCodeForImport={() => {}}
              invoice_attachmentRef={invoice_attachmentRef}
              additionalAttachmentRef={additionalAttachmentRef}
              setAttachInvoiceLoading={setAttachInvoiceLoading}
              physicalOrEInvoice={physicalOrEInvoice}
              changeHandler={changeHandler}
              alignForAttachment={true}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURLList={attachmentURLList}
              setAttachmentURL={setAttachmentURL}
              showAttachmentsHandler={showAttachmentsHandler}
              setOpenInvalidWarningDate={setOpenInvalidWarningDate}
              multipleData={multipleData}
              />*/}
            <InvoiceDetailTextField
              newFormState={formState}
              setNewFormState={setFormState}
              selectedRole="Line Manager"
              disabled={true}
              poBasedState={poBasedState}
              showVendorAndPO_NumberForImport={showVendorAndPO_NumberForImport}
              showVendorCodeForImport={() => { }}
              invoice_attachmentRef={invoice_attachmentRef}
              additionalAttachmentRef={additionalAttachmentRef}
              setAttachInvoiceLoading={setAttachInvoiceLoading}
              physicalOrEInvoice={physicalOrEInvoice}
              changeHandler={changeHandler}
              alignForAttachment={true}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURLList={attachmentURLList}
              setAttachmentURL={setAttachmentURL}
              showAttachmentsHandler={showAttachmentsHandler}
              setOpenInvalidWarningDate={setOpenInvalidWarningDate}
              multipleData={multipleData}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            lg={6}
            style={{ paddingLeft: "4px" }}
          >
            <Heading title="Attachment Preview">
              <span>
                {attachmentURLList != ""
                  ? attachmentURL == formState?.invoice_attachment?.path
                    ? " (Invoice Attachmnets)"
                    : "(Additional Documents)"
                  : null}
              </span>
            </Heading>

            <AttachmentsCover
              attachmentURLList={attachmentURLList}
              setAttachmentURLList={setAttachmentURLList}
              attachmentURL={attachmentURL}
              setAttachmentURL={setAttachmentURL}
              formState={formState}
              invoice_attachmentRef={invoice_attachmentRef}
            />
          </Grid>
        </Grid>
        <form onSubmit={confirmHandler} style={{ marginTop: "50 px" }}>
          {/* G/L Account */}
          {(newFormState?.invoiceCategory ===
            "Final Settlement – Death case") && (
              <Grid container style={{ marginTop: "10px", padding: " 0px 5px " }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Vendor_Table
                    // formState={newFormState}
                    // setFormState={setNewFormState}
                    formState={formState}
                    setFormState={setFormState}
                    disabled={true}
                  />
                </Grid>
              </Grid>
            )}

          <Grid container style={{ marginTop: "10px" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Heading title="G/L Account" />
              {
                formState?.isHR ?
                  <GL_Table_Detail_HR
                    formState={formState}
                  />
                  :
                  <GL_Table
                    // formState={newFormState}
                    // setFormState={setNewFormState}
                    formState={formState}
                    setFormState={setFormState}
                    show={false}
                    reviwerFlag={true}
                  />
              }
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: "10px", padding: " 0px 5px " }}>
            <CommentHistory
              commentsList={commentsList}
              commentsLoading={commentsLoading}
            />
          </Grid>
          <Grid
            container
            spacing={2}
            style={{ marginTop: "1px", padding: " 0px 5px " }}
          >
            {/*  <Grid item xs={12} sm={12} md={12} lg={3}>
              <Typography style={{color:"black"}}>Additional Documents:</Typography>
              <TextField
                fullWidth
                size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                // onChange={() => }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <input
                        ref={additionalAttachmentRef}
                        type="file"
                        name="additionalDocIds"
                        // required={
                        //   newFormState?.isReject === false
                        //     ? newFormState?.additionalDocIds.length === 0
                        //     : false
                        // }
                        onChange={(e) =>
                          uploadAdditioalDocumentFile(
                            e,
                            setNewFormState,
                            setAttachInvoiceLoading,
                            "additionalDocIds",
                            additionalAttachmentRef,
                            setDocError,
                            setAttachError,
                            setAlertMessage,
                            invoicePayload,
                            selectedRole,
                            dragfile,
                            setDragFile,
                            setSuccessMessage
                          )
                        }
                        style={{ width: "209px" }}
                      />
                    </InputAdornment>
                  ),
                }}
              />
              {newFormState?.additionalDocIds?.length > 0 &&
                newFormState?.additionalDocIds?.map((f, index) => {
                  const s = f?.path?.split("\\");
                  const ss = s[s.length - 1];
                  return (
                    <>
                      {f?.path !== "" ? (
                        <>
                          <Delete
                            color="danger"
                            fontSize="small"
                            disabled={f.role_Name !== selectedRole?.roleName}
                            onClick={() => {
                              setInvoiceDelete(f);
                              setWarningFlag(true);
                            }}
                            // onClick={() => {
                            //   const files =
                            //     newFormState?.additionalDocIds?.filter(
                            //       (x, i) => {
                            //         const n = x.split("\\");
                            //         const nn = n[n.length - 1];
                            //         return nn !== ss;
                            //       }
                            //     );
                            //   setNewFormState((formState) => ({
                            //     ...formState,
                            //     additionalDocIds: files,
                            //   }));

                            //   //removing data from attachemt list for preview
                            //   let filtered_attachs = attachmentURLList?.filter(
                            //     (x) => x !== f
                            //   );
                            //   setAttachmentURLList(filtered_attachs);
                            //   setAttachmentURL(
                            //     filtered_attachs[filtered_attachs.length - 1]
                            //   );
                            // }}
                          />

                          <Download
                            onClick={() => {
                              const files = newFormState.additionalDocIds.find(
                                (x, i) => {
                                  const n = x?.path?.split("\\");
                                  const nn = n[n.length - 1];
                                  return nn === ss;
                                }
                              );
                              downloadAttachments(files?.path);
                            }}
                          />
                          <IconButton
                            size="small"
                            onClick={() => {
                              const allowedExtensions = [
                                ".png",
                                ".pdf",
                                ".jpg",
                                ".jpeg",
                                ".PNG",
                                ".JPG",
                                ".JPEG",
                                ".PNG",
                                ".PDF",
                              ];
                              const fileExtension = "." + ss.split(".").pop();
                              if (allowedExtensions.includes(fileExtension)) {
                                setAttachmentURL(f);
                              } else {
                                setAttachmentURL(f);

                                window.open(
                                  `${process.env.REACT_APP_API_URL}/${f.path}`,
                                  "_blank"
                                );
                              }
                            }}
                          >
                            <span style={{ fontSize: "10px" }}>{ss}</span>
                          </IconButton>
                          <div></div>
                        </>
                      ) : (
                        ""
                      )}
                    </>
                  );
                })}
              </Grid>
            */}
          </Grid>
          {formState?.comments && (
            <Grid container style={{ margin: "20px 0px", padding: "0px 5px" }}>
              {/* Comments */}
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography style={{ color: "black" }}>Comments:</Typography>
                <TextField
                  fullWidth
                  multiline
                  rows={2}
                  maxRows={4}
                  size="small"
                  sx={{
                    // width: "70%",
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  name="comments"
                  required={newFormState?.isReject}
                  value={formState.comments}
                  onChange={(e) => {
                    setNewFormState({
                      ...newFormState,
                      comments: e.target.value,
                    });
                  }}
                />
              </Grid>
            </Grid>
          )}

          {/* 
         <Grid container style={{ margin: "20px 0px", padding: "0px 5px" }} display="flex" justifyContent={"flex-end"}>
          <Box display="flex" justifyContent={"flex-end"} mt={2}>
          <Button
            color="error"
            variant="contained"
            type="submit"
            onClick={() =>
              setNewFormState({ ...newFormState, isReject: true })
            }
          >
            Reject
          </Button>
          <Button
            color="secondary"
            variant="contained"
            type="submit"
            sx={{ ml: 2 }}
            onClick={() =>
              setNewFormState({ ...newFormState, isReject: false })
            }
          >
            Approve
          </Button>
        </Box>
        </Grid>*/}
        </form>
        {openWarningBox && (
          <WarningBox
            open={openWarningBox}
            close={() => setOpenWarningBox(false)}
            submit={submitHandler}
            message="Are you sure to Proceed the invoice"
          />
        )}
        {warningFlag && (
          <WarningBox
            open={warningFlag}
            close={() => setWarningFlag(false)}
            submit={deleteAttachmentFunc}
            message="Are you sure to delete attachment"
            deleteLoader={deleteLoader}
            allow={1}
          />
        )}
        {successMessage && (
          <CustomSnackbar
            open={successMessage !== ""}
            message={successMessage}
            handleClose={() => setSuccessMessage("")}
            variant="success"
          />
        )}
        {errorMessage && (
          <>
            {" "}
            <Grid container spacing={0}>
              <Grid item>
                <Error
                  titleAccess="Error"
                  className={classes.asterisk}
                  fontSize="small"
                />{" "}
              </Grid>
              <Grid item>
                <Typography className={classes.asterisk} ml={1}>
                  {" "}
                  {errorMessage}
                </Typography>
              </Grid>
            </Grid>
          </>
        )}
        {alertMessage && (
          <POAlertDialog
            setAlertMessage={setAlertMessage}
            message={attachError ? attachError : docError}
            setErrAlertMessage={() => { }}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default LM_SSM_DHRDetail;
